/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const FORM_DATA = [
    {
        label: "How many serialized items do you need?(max upto 1L)",
        name: "maxItems",
        type: "number-input",
        fieldProps: {}
    },
    {
        label: "Description (eg : First quarter items)",
        name: "description",
        type: "text-area",
        fieldProps: {}
    },

]

export const FIELDS: any ={
    count: {
        validators: {
            notEmpty: {
                message: "Number of QR code is required"
            },

        }
    },
}